import { render, staticRenderFns } from "./RulePopup.vue?vue&type=template&id=68ea659e&scoped=true"
import script from "./RulePopup.vue?vue&type=script&lang=js"
export * from "./RulePopup.vue?vue&type=script&lang=js"
import style0 from "./RulePopup.vue?vue&type=style&index=0&id=68ea659e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea659e",
  null
  
)

export default component.exports